export default __webpack_public_path__ + "static/media/riskPro.52f45921.png";